var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelFacebookSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 13,
  viewBox: "0 0 7 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.835 12.833V7.227H0v-2.52h1.835v-.813C1.835 1.38 2.245 0 5.505 0H6.78v2.29H5.505c-1.102 0-.936 1.212-.936 1.773v.644H7l-.72 2.52H4.57v5.606z"
})));
export default SvgChannelFacebookSm;